var _circle, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSelectedBreakouts = function SvgSelectedBreakouts(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 25,
    viewBox: "0 0 62 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.8184,
    cy: 19,
    r: 6,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.8828 8.3783L40.1173 10.5718",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9883 1L31.0051 5.35775",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1514 8.47791L21.9337 10.6422",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 20.3333H11.4848C15.4848 20.3333 18.6848 19.2666 20.8182 17.6666C23.4848 15.6666 25.4848 10.3333 30.8182 10.3333C36.1515 10.3333 38.8182 15.6666 40.1515 17.6666C41.4849 19.6666 44.1515 20.3333 46.8182 20.3333C48.9515 20.3333 56.1919 20.3333 60.6364 20.3333",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSelectedBreakouts);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjIiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCA2MiAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgc3R5bGU9Im1peC1ibGVuZC1tb2RlOm11bHRpcGx5Ij4KPGNpcmNsZSBjeD0iMzAuODE4NCIgY3k9IjE5IiByPSI2IiBmaWxsPSJ3aGl0ZSIvPgo8L2c+CjxwYXRoIGQ9Ik00My44ODI4IDguMzc4M0w0MC4xMTczIDEwLjU3MTgiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMC43NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik0zMC45ODgzIDFMMzEuMDA1MSA1LjM1Nzc1IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjAuNzUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTguMTUxNCA4LjQ3NzkxTDIxLjkzMzcgMTAuNjQyMiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIwLjc1IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTEgMjAuMzMzM0gxMS40ODQ4QzE1LjQ4NDggMjAuMzMzMyAxOC42ODQ4IDE5LjI2NjYgMjAuODE4MiAxNy42NjY2QzIzLjQ4NDggMTUuNjY2NiAyNS40ODQ4IDEwLjMzMzMgMzAuODE4MiAxMC4zMzMzQzM2LjE1MTUgMTAuMzMzMyAzOC44MTgyIDE1LjY2NjYgNDAuMTUxNSAxNy42NjY2QzQxLjQ4NDkgMTkuNjY2NiA0NC4xNTE1IDIwLjMzMzMgNDYuODE4MiAyMC4zMzMzQzQ4Ljk1MTUgMjAuMzMzMyA1Ni4xOTE5IDIwLjMzMzMgNjAuNjM2NCAyMC4zMzMzIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjAuNzUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K";